module.exports = __webpack_public_path__ + "static/media/IconModalAcessoModulos.c57d5bab.svg";